import styled from 'styled-components'

const MOBILE_BREAKPOINT = '768px'

export const HotsiteFormWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const HotsiteFormBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.4rem;
  background-color: var(--white);
  box-shadow: 0px 4px 10px 3px var(--shadow-smooth);
  overflow: hidden;
  width: 40rem;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    border-radius: 8px !important;

    margin: 16px !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
`
